export default __webpack_public_path__ + "static/media/milestones_disciple.1acf3412.svg";